var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6185 0C16.6743 0 16.7302 0 16.7892 0C16.9262 1.69253 16.2802 2.95719 15.495 3.87301C14.7246 4.78251 13.6697 5.6646 11.9635 5.53076C11.8497 3.86247 12.4967 2.69161 13.2808 1.77789C14.008 0.92636 15.3412 0.168621 16.6185 0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7836 17.6166C21.7836 17.6335 21.7836 17.6482 21.7836 17.6641C21.3041 19.1163 20.6201 20.3609 19.7855 21.516C19.0235 22.5646 18.0898 23.9757 16.4225 23.9757C14.9819 23.9757 14.025 23.0494 12.5485 23.0241C10.9866 22.9988 10.1277 23.7987 8.6997 24C8.53635 24 8.373 24 8.21281 24C7.1642 23.8482 6.31793 23.0178 5.70141 22.2695C3.88347 20.0585 2.47865 17.2025 2.21729 13.5476C2.21729 13.1893 2.21729 12.832 2.21729 12.4737C2.32794 9.85797 3.59892 7.73124 5.28829 6.70054C6.17987 6.15253 7.40553 5.68566 8.77031 5.89432C9.35521 5.98496 9.95276 6.1852 10.4765 6.38333C10.9729 6.57408 11.5937 6.91237 12.1817 6.89446C12.5801 6.88286 12.9763 6.67525 13.3779 6.52876C14.554 6.10405 15.7069 5.61715 17.2266 5.84585C19.053 6.12196 20.3493 6.93345 21.1502 8.18546C19.6052 9.16873 18.3838 10.6505 18.5925 13.1808C18.778 15.4794 20.1143 16.8241 21.7836 17.6166Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/apple-logo.c66abaf1.svg";
export { ForwardRef as ReactComponent };